// 체크박스 핸들러 함수들

export const createCheckboxHandler = (setSelectedItems) => {
    return (value, checked) => {
        if (checked) {
            setSelectedItems(prev => [...prev, value]);
        } else {
            setSelectedItems(prev => prev.filter(item => item !== value));
        }
    };
};

export const handleTypeChange = (setSelectedTypes) => 
    createCheckboxHandler(setSelectedTypes);

export const handleWorkTypeChange = (setSelectedWorkTypes) => 
    createCheckboxHandler(setSelectedWorkTypes);